<app-top-bar-wrapper [type]="DashboardType.MY_COMPETITION">
  <div dashboard class="main-container">
    <div class="tabs-container">
      <div class="tab" [ngClass]="{ 'active': activeTab() === MessagingRoutePaths.MARKETING_REPORT }"
        (click)="navigateTo(MessagingRoutePaths.MARKETING_REPORT)">
        <img [src]="'svg/my-competition-tab.svg' | assetVersion" alt="Report icon">
        <span>Creative Analysis</span>
      </div>
      <div class="tab" [ngClass]="{ 'active': activeTab() === MessagingRoutePaths.CREATIVE_GALLERY}"
        (click)="navigateTo(MessagingRoutePaths.CREATIVE_GALLERY)">
        <img [src]="'svg/gallery-green.svg' | assetVersion" alt="Gallery icon">
        <span>Gallery</span>
      </div>
    </div>
    <div *ngIf="shouldShowGroupingTypes" class="grouping-types-container">
      <span>
        Group By
      </span>
      <app-tabs [tabs]="groupingTypesLabels" [styleClass]="'messaging-types'" (emitter)="switchGroupingTypeTab($event)"></app-tabs>
    </div>
    <router-outlet></router-outlet>
  </div>
</app-top-bar-wrapper>